import React, { useState, /*useEffect*/ } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DynamicTable } from "@intervan-ar/ov-componentes";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import BlockComponent from "../../components/Loading/BlockComponent";
import Button from "../../components/Buttons/Button";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Cancel from "@material-ui/icons/Cancel";
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import pageStyle from "../../components/Page/PageStyle";
import tooltipStyle from "../../components/Tooltip/TooltipStyle";
import DDJJRIComponent from "./DDJJRIComponent";
import RemoveItemComponent from '../../components/RemoveItem/RemoveItemComponent';
import MessageComponent from '../../components/Message/MessageComponent';
import {downloadFile} from "../../core/downloadService";
import { browserHistory, getFullUrl } from '../../core/globals';

import {
	crearDDJJ,
	confirmarDDJJ,
	anularDDJJ
} from "../../core/DDJJComerciosRI/DDJJComerciosRI-actions";
import {getFacturaPDF} from "../../core/deudas/deudas-actions";
import {getTipoDeclaracion} from "../../core/DDJJComerciosRI/tipoDeclaracion";
import { setResumenPrevio } from '../../core/pagos/pagos-actions';

const styles = (theme) => ({
	...pageStyle(theme),
	...tooltipStyle(theme),
});

const ListadoComerciosRIComponent = ({classes, style, comercioIdSelected, data, handleOnClickNuevaDDJJ}) => {
  const [itemSelected, setItemSelected] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [message, setMessage] = useState({
    message: null,
    messageColor: null
  });
  const messageHelper = {
    resetMessage: () => {
      setMessage({message: null, messageColor: null});
    },
    setMessage: ({message, messageColor}) => {
      setMessage({message, messageColor})
      setTimeout(messageHelper.resetMessage, 1500);
    },
    setErrorMessage: (message) => {
      messageHelper.setMessage({ message, messageColor: 'error' })
    },
  };
  const ddjjComercios = useSelector((state) => {
    return state.DDJJComerciosRI
  });
  const loading = ddjjComercios.loadingDDJJComerciosRI;
  const dispatch = useDispatch();

	const tableListadoDDJJ = {
    columns: [
			{
				header: "Número",
				accessor: "nroDeclaracion",
				style: { textAlign: "center"},
				sortMethod: "(a, b) => { return Number(a) > Number(b) ? 1 : -1;}",
        minWidth: 7,
				filter: "Filtrar..."
			},
			{
				header: "Año",
				accessor: "anio",
				style: { textAlign: "center"},
				sortMethod: "(a, b) => { return Number(a) > Number(b) ? 1 : -1;}",
        minWidth: 5,
				filter: "Filtrar..."
			},
			{
				header: "Per.",
				accessor: "cuota",
				style: { textAlign: "center"},
				sortMethod: "(a, b) => { return Number(a) > Number(b) ? 1 : -1;}",
        minWidth: 5,
				filter: "Filtrar..."
			},
			{
				header: "Tipo",
				accessor: "tipoDeclaracionDescripcion",
				style: { textAlign: "center"},
				filter: "Filtrar...",
        minWidth: 6
			},
			{
				header: "Rec.",
				accessor: "rectificacion",
				style: { textAlign: "center"},
				filter: "Filtrar...",
        minWidth: 5
			},
			{
				header: "Valor",
				accessor: 'valor',
				style: { textAlign: "end"},
				sortMethod: "(a, b) => { return Number(a) > Number(b) ? 1 : -1;}",
        minWidth: 10,
				filter: "Filtrar...",
        tipo: "numero"
			},
			{
				header: "Importe",
				accessor: 'importe',
				style: { textAlign: "end"},
				sortMethod: "(a, b) => { return Number(a) > Number(b) ? 1 : -1;}",
        minWidth: 11,
				filter: "Filtrar...",
        tipo: "numero"
			},
			{
				header: "Saldo",
				accessor: 'saldo',
				style: { textAlign: "end"},
				sortMethod: "(a, b) => { return Number(a) > Number(b) ? 1 : -1;}",
        minWidth: 10,
				filter: "Filtrar...",
        tipo: "numero"
			},
			{
				header: "Estado",
				accessor: "estado",
        minWidth: 10,
				filter: "Filtrar...",
				style: { textAlign: "center"}
			},
		],
    defaultPageSize: 10,
    showPaginationTop: false,
    showPaginationBottom: true,
    className: "-striped -highlight",
    previousText: "<",
    nextText: ">",
    loadingText: "Cargando...",
    noDataText: "No se encontraron datos",
    pageText: "Página",
    ofText: "de",
    rowsText: "filas",
    toolbarOptions: {
      showToolbar: false
    },
    showFilters: false,
	};

  const tableActions = (row, rowIndex) => {
    const botonAnular = row.estado !== 'ANU'
      && row.estado === 'CON'
      && (
        <IconButton
          key={`anular${row.nroDeclaracion}`}
          onClick={() => {
            setItemSelected(row);
            setOpenRemoveModal(true);
          }}
          size="medium"
          className="remove"
          disabled={(row.estado !== 'CON')}
        >
          <Tooltip
          id="tooltip-remove"
          title="Anular"
          placement="top"
          classes={{tooltip: classes.tooltip}}
          >
            <Cancel color="error"/>
          </Tooltip>
        </IconButton>
      );
    const actionList = [
      (
        <IconButton
          key={`pagar${row.nroDeclaracion}`}
          onClick={() => {
            dispatch(setResumenPrevio({
              deuda: [{id: row.idFactura}],
              importeDeuda: row.importe
            }));
            const pathActual = browserHistory.location.pathname;
            sessionStorage.setItem("redireccionDespuesDePago", pathActual);
            browserHistory.push(getFullUrl('estado-deuda-pago'));
          }}
          size="medium"
          disabled={row.estado !== 'CON' || row.pagada !== "N"}
          className="remove"
          style={{
            color: row.estado !== 'CON' || row.pagada !== "N"
              ? "disabled" : "#2cb063"
          }}
        >
          <Tooltip
            id="tooltip-pagar"
            title="Pagar"
            placement="top"
            classes={{tooltip: classes.tooltip}}
          >
            <MonetizationOnIcon color="inherit"/>
          </Tooltip>
        </IconButton>
      ),
      botonAnular,
      (<IconButton
          key={`descargar${row.nroDeclaracion}`}
          onClick={() => onDownloadClick(row.idFactura)}
          className="download"
          color="primary"
          disabled={(row.estado !== 'CON' ? true : false)}
        >
          <Tooltip
            id="tooltip-download"
            title="Descargar Factura"
            placement="top"
            classes={{tooltip: classes.tooltip}}
          >
            <CloudDownloadIcon color="primary"/>
          </Tooltip>
        </IconButton>
      )
    ];
    return actionList;
  };

  const processData = (items) => {
    const { tiposDeclaraciones } = ddjjComercios;
    return items && Array.isArray(items) ?
      items.map((item) => ({
        ...item,
				tipoDeclaracionDescripcion: (getTipoDeclaracion(tiposDeclaraciones, item.tipoDeclaracion) || {}).descripcion,
      }))
      : [];
  };

	const onDownloadClick = (idFactura) => {
		const params = {
			idFactura
		};
		return Promise.resolve(dispatch(getFacturaPDF(params)))
		.then((data) =>{
			downloadFile(data, "factura_" + idFactura, "pdf")
			}).catch(error => {
				console.log(error);
			});
	};

	const handleAddClick = () => {
    setOpenModal(true);
    setItemSelected(null);
	};

	const _closeModals = () => {
    setOpenModal(false);
    setOpenRemoveModal(false);
    setItemSelected(null);
	};

	const handleCloseModal = () => {
    setOpenModal(false);
    setItemSelected(null);
	};

	const handleCloseRemoveModal = () => {
    setOpenRemoveModal(false);
    setItemSelected(null);
	};

	const _handleAdd = (data) => {
		delete data.fecha;
		delete data.fechaCalculoAnterior;
		delete data.idActividad;
    return dispatch(crearDDJJ)
	};

	const _handleUpdate = (id, data) => {
		return Promise.resolve({});
	};

	const handleOnSubmit = (item) => {
		const { nroDeclaracion, ...data } = item;
		const promise = nroDeclaracion ? _handleUpdate(nroDeclaracion, data) : _handleAdd(data);
		const successMessage = nroDeclaracion ? `DDJJ Actualizada Exitosamente.` : `DDJJ Creada Exitosamente.`;
		const errorMessage = nroDeclaracion ? `Error Actualizando DDJJ.` : `Error Creando DDJJ.`;
		return Promise.resolve(promise)
			.then(({nroDeclaracion}) => {
				messageHelper.setMessage({ messageColor: 'success', message: successMessage });
				return nroDeclaracion;
			})
			.catch((error) => {
				console.log('ERROR: ', error);
				messageHelper.setErrorMessage({ message: error.error || errorMessage });
			});
	};

	const handleOnConfirmar = (item) => {
		return dispatch(confirmarDDJJ(item))
			.then(() =>{
				messageHelper.setMessage({ messageColor: 'success', message: 'DDJJ confirmada exitosamente.' });
			})
			.catch((error) => {
				console.log('ERROR: ', error);
				messageHelper.setMessage({ messageColor: 'error', message: 'Error al confirmar DDJJ' });
			});
	};

	const handleOnAnular = (item) => {

		return dispatch(anularDDJJ(item))
			.then(() =>{
				messageHelper.setMessage({ messageColor: 'success', message: 'DDJJ anulada exitosamente.' });
			})
			.catch((error) => {
				console.log('ERROR: ', error);
				messageHelper.setMessage({ messageColor: 'error', message: 'Error al anular DDJJ' });
			});
	};

	const handleOnRemove = (item) => {
    setOpenRemoveModal(false);
		handleOnAnular(item);
	};

	const renderPageJump = (options) => {
		return (
			  <input
				style={{maxWidth:'60px'}}
				type="text"
				value={options.value}
				onBlur={options.onBlur}
				onChange={options.onChange}
				onKeyPress={options.onKeyPress}
			  />
		);
	}

  const botonNuevaDDJJ = (
    <Button
      color="primary"
      onClick={handleOnClickNuevaDDJJ}
    >
      Nueva DDJJ
    </Button>)

  return (
    <BlockComponent blocking={loading}>
    {comercioIdSelected && botonNuevaDDJJ}

    {openRemoveModal &&
        <RemoveItemComponent
      classes={classes}
      open={openRemoveModal}
      item={itemSelected}
      handleClose={handleCloseRemoveModal}
      handleOnRemove={handleOnRemove}
      title={`¿Esta seguro que desea anular la DDJJ?`}
      loading={loading}
        />}
    {openModal &&
        <DDJJRIComponent
      open={openModal}
      item={itemSelected}
      comercioIdSelected={comercioIdSelected}
      handleCloseModal={handleCloseModal}
      handleOnSubmit={handleOnSubmit}
      handleOnConfirmar={handleOnConfirmar}
      handleOnAnular={handleOnAnular}
      loading={loading}
      setErrorMessage={messageHelper.setErrorMessage}
        />}
    <DynamicTable
    table={tableListadoDDJJ}
    data={processData(data)}
    actions={tableActions}
    filterable
    renderPageJump={renderPageJump}
    style={{
      height: '500px'
    }}
    />
    <MessageComponent
    color={message.messageColor}
    message={message.message}
    />
    {comercioIdSelected && botonNuevaDDJJ}
    </BlockComponent>
  );
}

export default (withStyles(styles)(ListadoComerciosRIComponent));
